module.exports = __webpack_public_path__ + "static/assets/9446872cd4a9a962e1f0fa79553c028e.svg";